import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer data-testid="footer" className="relative bg-charcoal text-bone grain overflow-hidden">
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <span className="font-serif text-4xl md:text-5xl leading-none">In His Image</span>
            <p className="font-sans text-bone/60 mt-6 max-w-md leading-relaxed">
              Empowering men toward physical, emotional, and spiritual wellness through
              Christ-centered support.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-gold mb-5">Explore</p>
            <ul className="space-y-3 font-sans text-bone/70">
              <li><Link to="/devotionals" className="hover:text-gold transition-colors">Devotionals</Link></li>
              <li><Link to="/events" className="hover:text-gold transition-colors">Events</Link></li>
              <li><Link to="/directory" className="hover:text-gold transition-colors">Member Directory</Link></li>
              <li><Link to="/forum" className="hover:text-gold transition-colors">Community</Link></li>
              <li><Link to="/supporters" className="hover:text-gold transition-colors">Our Supporters</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-gold mb-5">Connect</p>
            <ul className="space-y-3 font-sans text-bone/70">
              <li><Link to="/about" className="hover:text-gold transition-colors">About Us</Link></li>
              <li><Link to="/#brotherhood" className="hover:text-gold transition-colors">Brotherhood</Link></li>
              <li><Link to="/#contact" className="hover:text-gold transition-colors">Contact Us</Link></li>
              <li><Link to="/register" className="hover:text-gold transition-colors">Become a Member</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-20 pt-8 border-t border-bone/15 flex flex-col md:flex-row justify-between gap-4 font-mono text-xs uppercase tracking-widest text-bone/40">
          <span>© {new Date().getFullYear()} In His Image Movement Ministries, Inc.</span>
          <span>Made in His image · Romans 8:29</span>
        </div>
      </div>
    </footer>
  );
}
